import { render, staticRenderFns } from "./index-cool.vue?vue&type=template&id=15da6210&scoped=true"
import script from "./index-cool.vue?vue&type=script&lang=js"
export * from "./index-cool.vue?vue&type=script&lang=js"
import style0 from "./index-cool.vue?vue&type=style&index=0&id=15da6210&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da6210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15da6210')) {
      api.createRecord('15da6210', component.options)
    } else {
      api.reload('15da6210', component.options)
    }
    module.hot.accept("./index-cool.vue?vue&type=template&id=15da6210&scoped=true", function () {
      api.rerender('15da6210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/index-cool.vue"
export default component.exports